module.exports = __webpack_public_path__ + "img/haruna.04fc8212.png";